import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: OperatorUpdateInput!
  ) {
    updateOneOperator(
      where: {
        id: $id
      }
      data: $data
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Operador actualizado`, mutationTypes.UPDATE)
)

